import { getDoc } from 'firebase/firestore/lite';
import pTimeout from 'p-timeout';

import { DBDocObject } from '../../../../common/src/legacy/objects/generic/db-doc/db-doc-object';
import { addDocToCache } from './cache/add-doc-to-cache';
import { getValueFromCache } from './cache/cache-value';
import { GetCollectionRefInput } from './get-collection-ref';
import { getDocPath } from './get-doc-path';
import { getDocRef } from './get-doc-ref';

export interface GetDocByIdInput<T> extends GetCollectionRefInput {
  id: string;
  defaultValue?: T;
  skipCache?: boolean;
}

export const getDocById = async <T>({
  id,
  defaultValue,
  Deserializer,
  skipCache,
}: GetDocByIdInput<T>): Promise<T | undefined> => {
  console.log('getDocById: Starting', id);

  const cacheId = await getDocPath({ id, Deserializer });
  const cached = skipCache ? undefined : getValueFromCache(cacheId);
  if (cached) {
    return cached as T;
  }
  const docRef = await getDocRef({ id, Deserializer });
  /**
   * There may be a better approach. In development, firebase security rules error did
   * not log an error without timeout.
   */
  const snapshot = await pTimeout(getDoc(docRef), { milliseconds: 15000 });
  const deserialized = snapshot?.data() as T | undefined;
  if (!deserialized) {
    console.log('Doc does not exist. Returning default');
    return defaultValue;
  }

  void addDocToCache({ doc: deserialized as unknown as DBDocObject, Deserializer });

  console.log('getDocById: Completed', deserialized);
  return deserialized;
};
